import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSEO } from "../lib/useSEO";
import { Container, SectionHeading, CTAButton, Eyebrow, Reveal } from "../components/site/ui";
import { IntegrationLayer } from "../components/site/IntegrationLayer";
import { CycleDiagram } from "../components/site/CycleDiagram";
import { AlertTriangle } from "lucide-react";

export default function Platform() {
  const { t, lang } = useLang();
  const p = t.platform;
  useSEO({ title: p.metaTitle, description: p.metaDesc, path: "/platform", lang });

  return (
    <div>
      <section className="pt-28 pb-16 border-b border-cool-dark" data-testid="platform-hero">
        <Container>
          <SectionHeading eyebrow={p.eyebrow} title={p.title} intro={p.intro} />
        </Container>
      </section>

      <section className="py-20 border-b border-cool-dark" data-testid="platform-cycle">
        <Container>
          <Eyebrow>Sense → Simulate → Solve → Execute</Eyebrow>
          <div className="mt-8"><CycleDiagram /></div>
        </Container>
      </section>

      <section className="py-20 border-b border-cool-dark" data-testid="platform-sections">
        <Container>
          <div className="divide-y divide-cool-dark border-y border-cool-dark">
            {p.sections.map((s, i) => (
              <Reveal key={i}>
                <div className="py-8 grid md:grid-cols-[0.4fr_1fr] gap-6">
                  <div className="flex items-start gap-4">
                    <span className="font-mono text-xs text-cyan pt-1">{String(i + 1).padStart(2, "0")}</span>
                    <h3 className="font-display text-xl text-white">{s.t}</h3>
                  </div>
                  <p className="text-cool-light leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <section className="py-20 border-b border-cool-dark bg-nb-deep" data-testid="platform-integration">
        <Container>
          <SectionHeading eyebrow="Integrazione" title={t.home.integrationTitle} />
          <div className="mt-10"><IntegrationLayer /></div>
        </Container>
      </section>

      <section className="py-16 border-b border-cool-dark" data-testid="platform-note">
        <Container>
          <div className="flex items-start gap-3 border border-cool-dark bg-nb-base p-5 max-w-3xl">
            <AlertTriangle size={18} className="text-gold mt-0.5 shrink-0" strokeWidth={1.8} />
            <p className="text-sm text-cool-light leading-relaxed">{p.note}</p>
          </div>
        </Container>
      </section>

      <section className="py-24" data-testid="platform-cta">
        <Container>
          <CTAButton to="/pilot-program" variant="primary" testId="platform-cta-btn">{t.common.applyPilot}</CTAButton>
        </Container>
      </section>
    </div>
  );
}
